import React, { useState } from 'react';
import './dashboard-profile-service.sass';
import { Button, ButtonSize, ButtonType } from '../../../../../components/interface/button/button';
import { useSelector } from 'react-redux';
import { getVendor } from '../../../../login/session.slice';
import { DashboardProfileImageUpload } from '../image-upload/dashboard-profile-image-upload';
import { Modal } from '../../../../../components/modal/modal';
import { EditProfile } from '../edit-profile/edit-profile';

export const DashboardProfileService = () => {

  const sessionData = useSelector(state => state.session);
  const [isEditing, setIsEditing] = useState(false);
  const vendor = getVendor(sessionData);

  const renderLabelWithText = ({label, text, i}) => {
    return <div key={i} className='vv-dashboard-profile-service__text-container'>
      <p className='vv-dashboard-profile-service__label'>{label}</p>
      <p className='vv-dashboard-profile-service__text'>{text}</p>
    </div>;
  };

  const profileProperties = [
    {label: 'Nazwa', text: vendor?.name, property: 'name'},
    {label: 'Branża', text: vendor?.category?.label},
    {label: 'Link do strony www', text: vendor?.url, property: 'url'},
    {label: 'Lokalizacja', text: vendor?.address, property: 'address'},
    {label: 'Opis', text: vendor?.description, property: 'description'},
  ];

  const renderDetails = () => {
    return <div key={isEditing} className='vv-dashboard-profile-service__data'>
      {profileProperties.map((e, i) => renderLabelWithText({...e, i}))}
    </div>;
  };

  const editProfile = () => {
    setIsEditing(true);
  };

  return (
    <div className='vv-dashboard-profile-service'>
      <h2 className='vv-dashboard-profile-service__title'>Profil usługi</h2>
      <p className='vv-dashboard-profile-service__description'>
        Profilowanie klientów oparte o kategorie wydarzeń, w których uczestniczą pozwala na lepsze dopasowanie do
        charakteru Twojej usługi.
      </p>
      <div className='vv-dashboard-profile-service__body'>
        { renderDetails() }
        <div className='vv-dashboard-profile-service__upload-container'>
          {
            vendor?.photos.map((photo, i) => {
              let profile = false;
              if (photo.id.toString() === vendor?.main_photo?.id) {
                profile = true;
              }
              return <div key={i} className='photo-margin-right'>
                        <DashboardProfileImageUpload img={photo.image_url} id={photo.id} isProfile={profile}/>
                     </div>;
            })
          }
          {
            vendor?.photos.length < 4 ?
                <DashboardProfileImageUpload/>
                : null
          }
        </div>
      </div>
      <div className='vv-dashboard-profile-service__button'>
        <Button buttonType={ButtonType.TRANSPARENT_BORDER} size={ButtonSize.VENDOR} onClick={() => editProfile()} text={'EDYTUJ'}/>
      </div>
      {
        vendor ?
            <Modal isOpen={isEditing} setVisible={setIsEditing} width={1196} height={740}>
                <EditProfile vendor={vendor} setIsVisible={setIsEditing}/>
            </Modal> :
            null
      }
    </div>
  );
};
